export enum DocsType {
  REMOVE_UI_DOC = 'REMOVE_UI_DOC',
  FETCH_SYNC_DOCS = 'FETCH_SYNC_DOCS',
  FETCH_SYNC_DOCS_ERROR = 'FETCH_SYNC_DOCS_ERROR',
  FETCH_SYNC_DOCS_SUCCESS = 'FETCH_SYNC_DOCS_SUCCESS',
  SET_SEATING_ORDER_MAP = 'SET_SEATING_ORDER_MAP',
  DOCUMENT_UI_LISTENERS_ADDED = 'DOCUMENT_UI_LISTENERS_ADDED',
  SET_UI_DOCUMENT = 'SET_UI_DOCUMENT',
  SET_BOOKING_DOCUMENT = 'SET_BOOKING_DOCUMENT',
  SET_PLAY_IN_DOCUMENT = 'SET_PLAY_IN_DOCUMENT',
  SET_SLIDES_DOCUMENT = 'SET_SLIDES_DOCUMENT',
  SET_QUESTIONS_DOCUMENT = 'SET_QUESTIONS_DOCUMENT',
  DOCUMENT_BOOKING_LISTENERS_ADDED = 'DOCUMENT_BOOKING_LISTENERS_ADDED',
  SET_BRIDGE_DATA_DOCUMENT = 'SET_BRIDGE_DATA_DOCUMENT',
  REMOVE_BRIDGE_DATA_DOCUMENT = 'REMOVE_BRIDGE_DATA_DOCUMENT',
  REMOVE_BOOKING_DOC = 'REMOVE_BOOKING_DOC',
  SET_BOOKING_STATUS = 'SET_BOOKING_STATUS',
  RESET_SESSION = 'RESET_SESSION'
}
